import { createSelector } from '@reduxjs/toolkit';
import { userInfoApi } from 'services/api/user-info/queries';

const selectUserInfoV1Result =
  userInfoApi.endpoints.getUserInfoV1.select(undefined);
const selectUserInfoV2Result =
  userInfoApi.endpoints.getUserInfoV2.select(undefined);

export const selectActiveUser = createSelector(
  [selectUserInfoV1Result, selectUserInfoV2Result],
  (userV1Result, userV2Result) => {
    return userV2Result.data || userV1Result.data;
  },
);
